import { Box, List, ListItem } from '@material-ui/core';
import { ReactElement } from 'react';
import { DeepMap, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Body1 } from '../../atoms';

import './form-validation-errors.styles.scss';

export interface IFormValidationErrors<T> {
	errors: DeepMap<T, FieldErrors>;
	submitCount: number;
}

export function FormValidationErrors<T>(
	props: IFormValidationErrors<T>
): ReactElement {
	const { errors, submitCount } = props;
	const { t } = useTranslation('contentManager');

	const flattenedErrors: string[] = getFlattenedErrors();

	function getFlattenedErrors(): string[] {
		const errorMessages: string[] = [];
		Object.keys(errors).forEach((property: string) => {
			const object: any = (errors as any)[property];
			if ('type' in object && 'message' in object) {
				errorMessages.push(object.message);
				return;
			}
			Object.keys(object).forEach((objectProperty: string) => {
				const childObject: any = object[objectProperty];
				if ('type' in childObject && 'message' in childObject) {
					errorMessages.push(childObject.message);
					return;
				}
			});
		});
		return errorMessages;
	}

	const hasErrors: boolean = flattenedErrors.length > 0;
	const showErrors: boolean = hasErrors && submitCount > 0;

	return (
		<Box className="form-validation-errors">
			{showErrors && (
				<>
					<Body1>{t('formErrors')}</Body1>
					<List>
						{flattenedErrors.map((error: string, index: number) => (
							<ListItem key={index}>{error}</ListItem>
						))}
					</List>
				</>
			)}
		</Box>
	);
}
